import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types
export const FETCH_DISTRICTS_REQUEST = "FETCH_DISTRICTS_REQUEST";
export const FETCH_DISTRICTS_SUCCESS = "FETCH_DISTRICTS_SUCCESS";
export const FETCH_DISTRICTS_FAILURE = "FETCH_DISTRICTS_FAILURE";

export const FETCH_MUNICIPALITIES_REQUEST = "FETCH_MUNICIPALITIES_REQUEST";
export const FETCH_MUNICIPALITIES_SUCCESS = "FETCH_MUNICIPALITIES_SUCCESS";
export const FETCH_MUNICIPALITIES_FAILURE = "FETCH_MUNICIPALITIES_FAILURE";

export const FETCH_WARDS_REQUEST = "FETCH_WARDS_REQUEST";
export const FETCH_WARDS_SUCCESS = "FETCH_WARDS_SUCCESS";
export const FETCH_WARDS_FAILURE = "FETCH_WARDS_FAILURE";

export const CLEAR_MUNICIPALITIES = "CLEAR_MUNICIPALITIES";
export const CLEAR_WARDS = "CLEAR_WARDS";

// Fetch Districts
export const fetchDistricts = () => async (dispatch) => {
  dispatch({ type: FETCH_DISTRICTS_REQUEST });

  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(`${BASE_URL}/v1/api/get-districts`, {
      headers: { authorization: token },
    });

    if (response.data.meta.status) {
      dispatch({
        type: FETCH_DISTRICTS_SUCCESS,
        payload: response.data.data,
      });
      return response.data;
    } else {
      dispatch({ type: FETCH_DISTRICTS_FAILURE });
      throw new Error(response.data.meta.message);
    }
  } catch (error) {
    dispatch({ type: FETCH_DISTRICTS_FAILURE });
    toast.error(
      error.response?.data?.meta?.message || "Failed to fetch districts",
    );
    throw error;
  }
};

// Fetch Municipalities by District ID
export const fetchMunicipalities = (districtId) => async (dispatch) => {
  if (!districtId) {
    dispatch({ type: CLEAR_MUNICIPALITIES });
    return;
  }

  dispatch({ type: FETCH_MUNICIPALITIES_REQUEST });

  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(
      `${BASE_URL}/v1/api/get-municipalities/${districtId}`,
      {
        headers: { authorization: token },
      },
    );

    if (response.data.meta.status) {
      dispatch({
        type: FETCH_MUNICIPALITIES_SUCCESS,
        payload: response.data.data,
      });
      return response.data;
    } else {
      dispatch({ type: FETCH_MUNICIPALITIES_FAILURE });
      throw new Error(response.data.meta.message);
    }
  } catch (error) {
    dispatch({ type: FETCH_MUNICIPALITIES_FAILURE });
    toast.error(
      error.response?.data?.meta?.message || "Failed to fetch municipalities",
    );
    throw error;
  }
};

// Fetch Wards by Municipality ID
export const fetchWards = (municipalityId) => async (dispatch) => {
  if (!municipalityId) {
    dispatch({ type: CLEAR_WARDS });
    return;
  }

  dispatch({ type: FETCH_WARDS_REQUEST });

  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(
      `${BASE_URL}/v1/api/get-wards/${municipalityId}`,
      {
        headers: { authorization: token },
      },
    );

    if (response.data.meta.status) {
      dispatch({
        type: FETCH_WARDS_SUCCESS,
        payload: response.data.data,
      });
      return response.data;
    } else {
      dispatch({ type: FETCH_WARDS_FAILURE });
      throw new Error(response.data.meta.message);
    }
  } catch (error) {
    dispatch({ type: FETCH_WARDS_FAILURE });
    toast.error(error.response?.data?.meta?.message || "Failed to fetch wards");
    throw error;
  }
};

// Clear municipalities (when district changes)
export const clearMunicipalities = () => ({
  type: CLEAR_MUNICIPALITIES,
});

// Clear wards (when municipality changes)
export const clearWards = () => ({
  type: CLEAR_WARDS,
});
